import { render, staticRenderFns } from "./SfPagination.vue?vue&type=template&id=1b681310&"
import script from "./SfPagination.vue?vue&type=script&lang=js&"
export * from "./SfPagination.vue?vue&type=script&lang=js&"
import style0 from "./SfPagination.vue?vue&type=style&index=0&id=1b681310&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports